import {createContext, useContext, useEffect, useState, useMemo} from 'react'
import {useMap} from '../hooks/useMap'
import {removeLayersBySource} from '../utils/sourceUtils'
import PropTypes from 'prop-types'

const SourceContext = createContext({
  id: ''
})
export const useSourceContext = () => useContext(SourceContext)

const Source = ({children, id, ...props}) => {
  const {map, styleLoaded} = useMap()

  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (styleLoaded) {
      if (['geojson', 'vector', 'raster', 'raster-dem', 'image', 'video'].includes(props.type)) {
        map?.addSource(id, props)
      }
      setIsLoaded(true)
    }

    return () => {
      removeLayersBySource(map, id)
      if (map?.getSource(id)) map?.removeSource(id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [styleLoaded])

  const contextValue = useMemo(() => ({id}), [id])

  return <SourceContext.Provider value={contextValue}>{isLoaded && children}</SourceContext.Provider>
}

Source.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['geojson', 'vector', 'raster', 'raster-dem', 'image', 'video']),
  children: PropTypes.node
}

export default Source

/**
 * List of functions and their purpose:
 *
 * - Source: Manages the lifecycle of a Maptiler source and provides its ID to child Layer components via context.
 * - useSourceContext: Provides access to the source ID from the Source context.
 */
